<ng-container *transloco="let t">
<div class="row">
  <div class="p-2 px-5 col-md-3" style="min-height: 70px;">
    <div class="d-flex align-items-center mb-2">
      <div class="symbol symbol-40px symbol-lg-80px symbol-fixed position-relative me-4">
        <span class="svg-icon svg-icon-2x svg-icon-primary">
          <duotone-bank-svg-icon></duotone-bank-svg-icon>
        </span>
      </div>
      @if (!inEditMode) {
        <a
          (click)="onLoanDetailsClicked()"
          href="javascript:void(0)"
          class="text-gray-800 text-hover-primary fs-4 fw-bolder me-1">
          {{ step | localizedLabel:'loanDetailsSectionTitle':'wizard.review.loanDetails' }}
        </a>
      }
      @if (inEditMode) {
        <input [name]="'loanDetailsCaption'" type="text"
          class="form-control form-control-solid fs-4 fw-bolder" [(ngModel)]="step.loanDetailsSectionTitle" />
      }
    </div>
  </div>
  <div class="p-2 px-5 col-md-3" style="min-height: 70px;">
    <div class="mb-3">
      <div class="text-gray-400 fw-bold">{{ t('wizard.loanSummary.purpose') }} <span class="text-gray-800 fw-bold">{{purposeOfLoan}}</span></div>
    </div>
    <div class="mb-3">
      <div class="text-gray-400 fw-bold">{{ t('wizard.loanSummary.type') }} <span class="text-gray-800 fw-bold">{{mortgageAppliedFor}}</span></div>
    </div>
  </div>
  <div class="p-2 col-md-3 px-5" style="min-height: 70px;">

    @if (!isHidden('mortgage.transactionDetail.purchasePriceAmount') && purposeOfLoan !== 'Refinance') {
      <div class="mb-3">
        <div class="text-gray-400 fw-bold">
          {{getLabel('mortgage.transactionDetail.purchasePriceAmount', t('wizard.loanSummary.purchasePrice'))}} <span class="text-gray-800 fw-bold">{{transactionDetail.purchasePriceAmount | currency}}</span></div>
      </div>
    }
    @if (purposeOfLoan === 'Refinance') {
      <div class="mb-3">
        @if (hasAppraisedValue) {
          <div class="text-gray-400 fw-bold">{{ t('wizard.loanSummary.appraisedValue') }} <span class="text-gray-800 fw-bold">{{appraisedValue | currency}}</span></div>
        } @else {
          <div class="text-gray-400 fw-bold">{{ t('wizard.loanSummary.estimatedValue') }} <span class="text-gray-800 fw-bold">{{subjectProperty.presentValue | currency}}</span></div>
        }
      </div>
    }
    <div class="mb-3">
      <div class="text-gray-400 fw-bold">{{ t('wizard.loanSummary.ltv') }} <span class="text-gray-800 fw-bold">{{ltv | number : '1.2-2'}} %</span></div>
    </div>
  </div>
</div>
</ng-container>
